// extracted by mini-css-extract-plugin
module.exports = {"navbar":"MainMenu_navbar_1aJJK","nav":"MainMenu_nav_2ZO5M","logo":"MainMenu_logo_2Tum3"};